import { specProgReqActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false,
    replyVisible: false
};

export const reducer = createReducer(initialState, {
    [specProgReqActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.nono;
        state.replyVisible = false;
    },
    [specProgReqActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. nono: ' + action.payload.nono + ' error: ' + action.payload.error);
    },
    [specProgReqActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [specProgReqActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [specProgReqActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading notes pending action. error: ' + action.payload.error);
    },
    [specProgReqActions.replySuccess]: (state, action) => {
        state.selectedMessage = undefined;
        state.replyVisible = false;
    },
    [specProgReqActions.replyFailure]: (state, action) => {
        log.error('Error replying sxno: ' + action.payload.sxno + ' error: ' + action.payload.error);
    },
    [specProgReqActions.toggleReply]: (state, action) => {
        state.replyVisible = !state.replyVisible;
    }

   
})


